import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DonationCardService } from '../../../services/donation-card.service';
import {
  DonorGeneralInformationVM
} from '../../../models/DonationCardModels';


@Component({
  selector: 'app-donor-info-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './donor-info-tab.component.html'
})
export class DonorInfoTabComponent implements OnInit {
  @Input() donationId!: number;
  @Input() isReadOnlyMode: boolean = true;
  donorInfo?: DonorGeneralInformationVM;
  constructor(private service: DonationCardService) { }
  ngOnInit() { this.service.getDonorInfo(this.donationId).subscribe(data => this.donorInfo = data); }
}
